module.exports = __webpack_public_path__ + "static/img/image_we_07_01.53e0014.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/home/image_we_07_01.png
// module id = GMn5
// module chunks = 10